import Button from "@/components/bricks/button/Button";
import { QUERY_PAGE_SIZE } from "../../api/util";
import ChevronLeftIcon from "../icons/ChevronLeftIcon";
import ChevronRightIcon from "../icons/ChevronRightIcon";

export default function Pagination(props: {
  page: number;
  totalCount: number;
  pageSize?: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onNextClick: () => void;
  onPreviousClick: () => void;
}) {
  const {
    page,
    totalCount,
    pageSize = QUERY_PAGE_SIZE,
    hasPreviousPage,
    hasNextPage,
    onNextClick,
    onPreviousClick,
  } = props;

  return (
    <div className="c-pagination">
      <div className="c-pagination__text">
        {(page - 1) * pageSize + 1} -{" "}
        {page * pageSize > totalCount ? totalCount : page * pageSize}
        <span className="text-muted"> af {totalCount}</span>
      </div>
      <div className="c-pagination__links">
        <Button
          color="secondary"
          icon
          transparent
          disabled={!hasPreviousPage}
          aria-label="Forrige"
          onClick={() => {
            onPreviousClick();
          }}
        >
          <ChevronLeftIcon />
        </Button>
        <Button
          disabled={!hasNextPage}
          color="secondary"
          icon
          transparent
          aria-label="Næste"
          onClick={() => onNextClick()}
        >
          <ChevronRightIcon />
        </Button>
      </div>
    </div>
  );
}
